export default "__VITE_ASSET__C8SF8xNI__"